module.exports = __webpack_public_path__ + "img/Talk Graphic 900.f48863c5.jpg";